import { useMemo } from 'react'
import { globalShops } from '../config/shops'
import { platformLabels } from '../i18n/messages'
import { useLocale } from '../i18n/LocaleContext'
import { usePublicLinks } from './usePublicLinks'

/** Footer «Dove acquistare» (Public links con site attivo, altrimenti shops.js). */
export function useShopLinks() {
  const { locale, pick } = useLocale()
  const { links: cmsLinks } = usePublicLinks({ site: true })

  return useMemo(() => {
    if (cmsLinks.length > 0) {
      return cmsLinks.map((link) => ({
        id: link.id,
        label: pick(link.label),
        url: link.url,
      }))
    }
    return globalShops.map((shop) => ({
      id: shop.id,
      label: platformLabels[shop.platform]?.[locale] ?? shop.platform,
      url: shop.url,
    }))
  }, [cmsLinks, locale, pick])
}
